import styled from 'styled-components';
import { COLORS } from '../../../styles/colors';

export const Divider = styled.div`
  margin: 24px 0;
  border-top: 1px solid ${COLORS.grey[400]};
`;
